import { useQuery } from "@tanstack/react-query";
import { axios } from "lib/axios";

export const getChurch = ({
  churchId,
  isPublic,
  isDenomination,
  denominationId
}) => {
  if (isDenomination) {
    return axios.get(`/denominations/${denominationId}/churches/${churchId}`);
  }

  if (isPublic) {
    return axios.get(`/church/${churchId}`);
  }

  return axios.get(`/churches/${churchId}`);
};

export const useChurch = ({
  churchId,
  isPublic = false,
  isDenomination = false,
  denominationId,
  config
} = {}) => {
  return useQuery({
    ...config,
    queryKey: ["church", churchId, isPublic, denominationId, isDenomination],
    queryFn: () =>
      getChurch({ churchId, isPublic, denominationId, isDenomination })
  });
};
